import $ from "jquery";

const $body = $('body');

function init (element) {
    const $wrap = $(element);
    const $tariffTable = $wrap.find('[data-tariff-table]');
    const $serviceTable = $wrap.find('[data-service-table]');
    const $warehouseSelect = $wrap.find('#warehouseSelect');
    const translates = window.translates['cargo-instruction'];
    const tableEmptyClass = 'cargo-table--empty';
    
    getTariffCost();
    
    $warehouseSelect.on('change', function (e) {
        const val = $(this).val();
        const notReload = e.params ? e.params.notReload : false;
        getService(val, notReload);
    });
    
    function getTariffCost () {
        $body.addClass('is-loading');
        $.ajax({
            url: '/' + window.currentLang + '/SharedForms/GetTarifCost',
            type: 'get',
            success: (response) => {
                constructTariffTable(response.tarifCost);
                constructSelectOptions(response.cityAddList);
                $body.removeClass('is-loading');
            }
        });
    }
    
    function getService (id, notReload = false) {
        if (!notReload) {
            if (id !== 'null') {
                $serviceTable.addClass('is-loading');
                $.ajax({
                    url: '/' + window.currentLang + '/Home/GetAuxNumbers',
                    type: 'get',
                    data: {
                        id
                    },
                    success: (response) => {
                        constructServiceTable(response);
                        $serviceTable.removeClass('is-loading');
                    }
                });
            } else {
                constructServiceTable([]);
            }
        }
    }
    
    function constructTariffTable (data) {
        let result = `
            <tr>
                <th>${translates.tarifWeightVolum}</th>
                <th>${translates.tarifCost}</th>
            </tr>
        `;

        $.each(data, (i, elem) => {
            result += `
                <tr>
                    <td>${elem.Name}</td>
                    <td>${elem.Cost.toLocaleString(window.currentLang, {
                       minimumFractionDigits: 2,
                       maximumFractionDigits: 2
                    })}</td>
                </tr>
           `; 
        });
        
        $tariffTable.html(result);
    }
    
    function constructSelectOptions (data) {
        let result = `<option value="null">${translates.notChosen}</option>`;
        
        $.each(data, (i, elem) => {
            if (elem.Value === null) return;
            result += `<option value="${elem.Value}">${elem.Text}</option>`;
        });

        $warehouseSelect.html(result).trigger({
            type: 'change',
            params: {
                notReload: true
            }
        });
    }
    
    function constructServiceTable (data) {
        $serviceTable.removeClass(tableEmptyClass);
        
        let result = `
            <tr>
                <th>${translates.connectedWarehouse}</th>
                <th>${translates.tarif}</th>
                <th>${translates.tarifCost}</th>
            </tr>
        `;
        
        if (data.length > 1) {
            result += `
                <tr>
                    <td rowspan="${data.length + 1}">${data[1].WarehouseName !== null ? data[1].WarehouseName : ''}  </td>
                    <td>${data[0].Name}</td>
                    <td>${data[0].Cost !== null ? data[0].Cost.toLocaleString(window.currentLang, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }) : '-'}</td>
                </tr>
                <tr>
                    <td>${data[1].Name}</td>
                    <td>${data[1].Cost !== null ? data[1].Cost.toLocaleString(window.currentLang, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }) : '-'}</td>
                </tr>
            `;
        } else if(data.length === 1) {
            result += `
                <tr>
                    <td>${data[0].WarehouseName}</td>
                    <td>${data[0].Name}</td>
                    <td>${data[0].Cost !== null ? data[0].Cost.toLocaleString(window.currentLang, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }) : '-'}</td>
                </tr>
            `;
        } else {
            result += `
                <tr>
                    <td colspan="4">
                        <svg>
                            <use xlink:href="#boxes"></use>
                        </svg>
                    </td>
                </tr>
            `;
            $serviceTable.addClass(tableEmptyClass);
        }
        
        for (let i = 2; i < data.length; i++) {
            result += `
                <tr>
                    <td>${data[i].Name}</td>
                    <td>${data[i].Cost !== null ? data[i].Cost.toLocaleString(window.currentLang, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }) : '-'}</td>
                </tr>
           `;
        }

        $serviceTable.html(result);
    }
}

export default function (element) {
    init(element);
}